import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=cd972dae&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=cd972dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd972dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd972dae')) {
      api.createRecord('cd972dae', component.options)
    } else {
      api.reload('cd972dae', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=cd972dae&scoped=true&", function () {
      api.rerender('cd972dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cdfWpux2afFE/JS/teamMember.vue"
export default component.exports